type AddressStreetInfoWithRegion = {
  streetNumber: string;
  streetName: string;
  streetAdditional: string;
  city: string;
  regionName: string;
  postcode: string;
  countryName: string;
  hidePostCode?: boolean;
  isReversed?: boolean;
  showRegionField?: boolean;
};

export const AddressStreetInfoWithRegion = ({
  streetNumber,
  streetName,
  streetAdditional,
  regionName,
  city,
  postcode,
  countryName,
  isReversed,
  hidePostCode = false,
}: AddressStreetInfoWithRegion) => {
  const streetInfo = isReversed
    ? `${streetNumber} ${streetName} ${streetAdditional}`
    : `${streetName} ${streetNumber} ${streetAdditional}`;

  const cityWithPostcode = hidePostCode || !postcode ? city : `${city} ${postcode}`;
  const addressInfo = [regionName, cityWithPostcode, countryName].filter(Boolean).join(", ");

  return (
    <>
      <p>{streetInfo}</p>
      <p>{addressInfo}</p>
    </>
  );
};
